import { NgTemplateOutlet } from '@angular/common';
import { Component, DestroyRef, TemplateRef, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NumberToArrayPipe, VolumePercentagePipe } from '@zero/shared/ui-pipes';
import { IconComponent, ModalComponent } from '@zero/shared/ui-web-design-system';
import { WeightingType } from '@zero/statistics/domain';
import { WeightingBase } from '@zero/statistics/feature-statistics/base';
import { BaseChartDirective } from 'ng2-charts';

@Component({
  selector: 'statistics-weighting',
  templateUrl: './weighting.component.html',
  styleUrls: ['./weighting.component.scss'],
  imports: [TranslocoPipe, BaseChartDirective, VolumePercentagePipe, NgTemplateOutlet, ModalComponent, NumberToArrayPipe, IconComponent],
})
export class WeightingComponent extends WeightingBase {
  public readonly modal = inject(NgbModal);
  readonly #destroyRef = inject(DestroyRef);

  @ViewChild('modalContent', { read: TemplateRef }) public modalContent: TemplateRef<unknown>;

  public openModal = async (): Promise<void> => {
    this.type === WeightingType.TOP_POSITIONS && this.statisticsFacade.loadWeightingByPositions();
    const activeModal: NgbModalRef = this.modal.open(this.modalContent, { size: 'fullscreen' });
    activeModal.dismissed
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(() => this.type === WeightingType.ALL_POSITIONS && this.statisticsFacade.loadWeightingByTopPositions());
  };
}
